import { useEffect, useState } from "react";
import { useParams } from "react-router";
import { Spin, Typography, message } from "antd";
import { authService } from "@/services/auth";

const { Text } = Typography;

export function SsoLoginPage() {
  const { orgId } = useParams<{ orgId: string }>();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!orgId) {
      setError("Missing organization ID");
      return;
    }

    const callbackUrl = `${window.location.origin}/sso/callback`;

    authService.ssoAuthorize(orgId, callbackUrl)
      .then((result) => {
        // Store orgId for callback page
        sessionStorage.setItem("sso_org_id", orgId);
        // Redirect to OIDC provider
        window.location.href = result.authorize_url;
      })
      .catch((err) => {
        setError(err instanceof Error ? err.message : "SSO authorization failed");
        message.error(error);
      });
  }, [orgId]);

  if (error) {
    return (
      <div style={{ height: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Text type="danger">{error}</Text>
      </div>
    );
  }

  return (
    <div style={{ height: "100vh", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: 16 }}>
      <Spin size="large" />
      <Text type="secondary">Redirecting to SSO provider...</Text>
    </div>
  );
}
